import { render, staticRenderFns } from "./SjiModerationScreen.vue?vue&type=template&id=1b2d2838&scoped=true"
import script from "./SjiModerationScreen.vue?vue&type=script&lang=js"
export * from "./SjiModerationScreen.vue?vue&type=script&lang=js"
import style0 from "./SjiModerationScreen.vue?vue&type=style&index=0&id=1b2d2838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d2838",
  null
  
)

export default component.exports